import type { IssuedCredentials } from './issued-credentials'
import type { ResetTarget } from './ResetUsernamePasswordDialog'
import { useState } from 'react'
import IssuedCredentialsDialog from './IssuedCredentialsDialog'
import ResetUsernamePasswordDialog from './ResetUsernamePasswordDialog'

/**
 * Le parcours des identifiants d'apprenants en pseudo (#271), partagé par la
 * liste et la fiche : réinitialiser après confirmation, puis montrer UNE fois
 * ce qui a été émis (création, import ou réinitialisation). `dialogs` est à
 * rendre par l'écran.
 */
export function useCredentialsFlow() {
  const [issued, setIssued] = useState<IssuedCredentials[] | null>(null)
  const [resetting, setResetting] = useState<ResetTarget | null>(null)

  const dialogs = (
    <>
      {resetting && (
        <ResetUsernamePasswordDialog
          learner={resetting}
          onCancel={() => setResetting(null)}
          onIssued={(credentials) => {
            setResetting(null)
            setIssued([credentials])
          }}
        />
      )}
      {issued && <IssuedCredentialsDialog credentials={issued} onClose={() => setIssued(null)} />}
    </>
  )

  return { showIssued: setIssued, startReset: setResetting, dialogs }
}
